import { VALIDATION_MESSAGE } from "@/constants/validation-message";
import { z } from "zod";

const loginSchema = z.object({
  username: z.string().min(2, {
    message: VALIDATION_MESSAGE.get("Username", "greater_than", 2),
  }),
  password: z.string().min(6, {
    message: VALIDATION_MESSAGE.get("Password", "greater_than", 6),
  }),
});

export default loginSchema;
